import React, { useState } from 'react'
import SideBar from './SideBar'
import DashboardHeader from './DashboardHeader'

const DashboardContainer = ({ content, pageTitle }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(true);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    return (
        <div className='dashboard'>
            <SideBar mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} sidebarCollapsed={sidebarCollapsed} />
            <div className={`dashboard-content ${sidebarCollapsed ? 'expanded' : ''}`}>
                <DashboardHeader
                 mobileMenuOpen={mobileMenuOpen}
                  setMobileMenuOpen={setMobileMenuOpen}
                  pageTitle={pageTitle}
                  unreadCount={unreadCount}
                  setUnreadCount={setUnreadCount}
                  sidebarCollapsed={sidebarCollapsed}
                  setSidebarCollapsed={setSidebarCollapsed}
                   />
                <div className="content">
                    {content}
                </div>
            </div>
        </div>
    )
}

export default DashboardContainer;